import React from "react";
import "./styles.scss";
export default function FunMode() {
  return (
    <div className="wrap-fun-mode">
      <p className="label-fun-mode">
        <span>Fun</span> Mode
      </p>
    </div>
  );
}
